import { Transport } from 'viem'
import {
  arbitrum,
  arc,
  arcTestnet,
  avalanche,
  avalancheFuji,
  base,
  baseSepolia,
  bsc,
  celo,
  gnosis,
  mainnet,
  optimism,
  optimismSepolia,
  polygon,
  scroll,
  sepolia
} from 'viem/chains' // prolly not a fantastic approach for bundle size
import { createConfig, http } from 'wagmi'

import { networks } from '../redux/networks'

const allWagmiChains = [
  mainnet,
  gnosis,
  polygon,
  optimism,
  arbitrum,
  avalanche,
  bsc,
  celo,
  base,
  scroll,
  arc,
  avalancheFuji,
  sepolia,
  optimismSepolia,
  baseSepolia,
  arcTestnet
] as const

if (allWagmiChains.length !== networks.length) {
  throw new Error(
    'Mismatch between wagmi chains and app networks. Please update to keep in sync'
  )
}

type WagmiChainId = (typeof allWagmiChains)[number]['id']

export const wagmiConfig = createConfig({
  chains: allWagmiChains,
  transports: networks.reduce(
    (acc, curr) => {
      acc[curr.chainId] = http(curr.rpcUrl)
      return acc
    },
    {} as Record<WagmiChainId, Transport>
  ),
  batch: { multicall: true }
})
